import './App.css';
import W2S from './Components/W2S'

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <W2S />
      </header>
    </div>
  );
}

export default App;

// https://my.snuba.com/api/diveplugin.php?a=divedata